import { Object3D } from 'three';
import { Time } from 'ohzi-core';

import StationaryState from '../states/StationaryState';
import FlyToState from '../states/FlyToState';


export default class StateHandler {

	constructor(camera_controller) {
		this.stationary_state = new StationaryState(camera_controller, this);
		this.fly_to_state = new FlyToState(camera_controller, this);
		this.current_state = this.stationary_state;
		this.camera_controller = camera_controller;
		
	}

	set_up(scene) {
		this.current_state.set_up(scene);
	};

	go_to_fly(other_sub_scene_handler) {
		this.fly_to_state.set_up(this.stationary_state.sub_scene_handler, other_sub_scene_handler);
		this.current_state = this.fly_to_state;
	};

	go_to_stationary(end_sub_scene) {
		this.stationary_state.set_up(end_sub_scene);
		this.current_state = this.stationary_state;
	};

	go_to() {
	};

	fade_out () {

	};

	fade_in () {

	};

	animate() {

	};

	update(camera_controller) {
		if ( !this.current_state ) { console.error('scene not yet defined'); return;}
		this.current_state.update();
	};
}